var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustimg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 109.264 109.264 120 60 120C10.7357 120 0 109.264 0 60C0 10.7357 10.7357 0 60 0C109.264 0 120 10.7357 120 60Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3539 86.4596C37.121 81.7918 30 71.4684 30 59.482C30 47.5038 37.121 37.1722 47.3539 32.5044",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6978 33.3853C82.9757 38.3906 89.2735 48.2036 89.2735 59.482C89.2735 70.7604 82.9674 80.5734 73.6978 85.5787",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8755 50.838V68.126L59.6362 76.7701L74.4051 68.126V50.838L59.6362 42.194L44.8755 50.838Z",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8755 50.838L59.6362 59.482V76.7701",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4057 50.838L59.6367 59.482",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3677 46.4583L67.0214 55.16V59.0127",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2603 88.0895L48.671 83.1583C48.424 82.8208 47.8971 82.8867 47.7407 83.2736C47.6995 83.3724 47.6831 83.4794 47.6748 83.5946C47.6501 84.5578 47.4608 85.5375 47.0739 86.4925C46.687 87.4474 46.1519 88.2789 45.4933 88.9951C45.4192 89.0774 45.3615 89.168 45.3204 89.2668C45.164 89.6537 45.4933 90.0653 45.9131 89.9912L51.9228 88.9375C52.3097 88.8716 52.499 88.4106 52.2603 88.0978V88.0895Z",
    fill: "#0A090A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7166 31.2284L71.7709 36.5053C71.9849 36.8676 72.5118 36.8593 72.7094 36.4889C72.7587 36.3901 72.7917 36.2831 72.8081 36.176C72.9316 35.2128 73.228 34.2661 73.7055 33.3605C74.183 32.455 74.8086 31.6811 75.5413 31.039C75.6236 30.9649 75.6895 30.8826 75.7471 30.7838C75.9447 30.4133 75.6566 29.9688 75.2367 30.0017L69.153 30.4216C68.7578 30.4463 68.5273 30.8826 68.7249 31.2284H68.7166Z",
    fill: "#0A090A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustimg4);
export default __webpack_public_path__ + "static/media/trustimg4.7c0959787cb4dedb82ffd875866d4a6d.svg";
export { ForwardRef as ReactComponent };